import { convertBytesToMB } from '../../utils/convertBytesToMB';

const SELECTORS = {
	textarea: '#description',
	removeDocumentBtn: '.remove-document-button',
	listItem: '[data-list-item]',
	fileInput: '[type="file"]',
	uploadedBlock: '.uploaded-document-card',
	confirmCta: '.confirm-document-removing',
	hiddentInput: '[type="hidden"]',
	modalId: 'delete-file-modal',
	fileName: '[data-file-name]',
	fileExtension: '[data-file-extension]',
	fileSize: '[data-file-size]',
	uploadFileBlock: '.upload-document-card__field',
};

const CLASSES = {
	displayNone: 'display--none',
};

export class MedicalDocuments {
	constructor() {
		this.textarea = document.querySelectorAll(SELECTORS.textarea);
		this.removeDocumentBtns = document.querySelectorAll(SELECTORS.removeDocumentBtn);
		this.listItems = document.querySelectorAll(SELECTORS.listItem);
		this.fileInputs = document.querySelectorAll(SELECTORS.fileInput);
		this.confirmCta = document.querySelector(SELECTORS.confirmCta);
		this.fileName = document.querySelectorAll(SELECTORS.fileName);
		this.fileExtension = document.querySelectorAll(SELECTORS.fileExtension);
		this.fileSize = document.querySelectorAll(SELECTORS.fileSize);
		this.uploadFileBlocks = document.querySelectorAll(SELECTORS.uploadFileBlock);

		const requiredElements = [this.textarea.length];

		if (requiredElements.some((el) => !el)) {
			return;
		}

		this.bindEvents();
		this.setup();
	}

	static init() {
		console.log('Medical document init');
		// eslint-disable-next-line
		new MedicalDocuments();
	}

	bindEvents() {
		['handleFileUpload', 'removeDocument', 'confirmRemove'].forEach((e) => {
			this[e] = this[e].bind(this);
		});
	}

	handleFileUpload(e, index) {
		const { size, name } = e.target.files[0];

		const parentEl = this.listItems[index];

		const fileName = this.fileName[index];
		const fileExtension = this.fileExtension[index];
		const fileSize = this.fileSize[index];
		const uploadFileBlocks = this.uploadFileBlocks[index];

		fileName.textContent = name;
		fileExtension.textContent = name.slice(name.lastIndexOf('.') + 1).toUpperCase();
		fileSize.textContent = `${convertBytesToMB({ size })} MB`;

		const uploadedBlockEl = parentEl.querySelector(SELECTORS.uploadedBlock);
		uploadedBlockEl.classList.remove(CLASSES.displayNone);
		uploadFileBlocks.classList.add(CLASSES.displayNone);
	}

	removeDocument(e, index) {
		this.parentElWhichFileRemove = this.listItems[index];
		this.elementToRemove = this.parentElWhichFileRemove.querySelector(SELECTORS.uploadedBlock);

		this.indexToRemove = index;
	}

	confirmRemove() {
		const parent = this.listItems[this.indexToRemove];
		const fileInputToClean = this.fileInputs[this.indexToRemove];
		const uploadFileBlocks = this.uploadFileBlocks[this.indexToRemove];

		fileInputToClean.value = null;
		const hiddenInputEl = parent.querySelector(SELECTORS.hiddentInput);
		if (hiddenInputEl) hiddenInputEl.value = 1;

		this.elementToRemove?.classList.add(CLASSES.displayNone);
		uploadFileBlocks.classList.remove(CLASSES.displayNone);
	}

	setupEventListeners() {
		this.removeDocumentBtns.forEach((e, index) =>
			e.addEventListener('click', (event) => this.removeDocument(event, index))
		);
		this.fileInputs.forEach((e, index) =>
			e.addEventListener('change', (event) => this.handleFileUpload(event, index))
		);
		this.confirmCta.addEventListener('click', this.confirmRemove);
	}

	setup() {
		this.elementToRemove = null;
		this.parentElWhichFileRemove = null;
		this.indexToRemove = null;

		this.setupEventListeners();
	}
}
